export default __webpack_public_path__ + "static/media/ContactUS.e0ee8fa2.svg";